import { AutocompleteValue, ParticipantsValue, AutocompleteListenerCallbackFN, ParticipantsListenerCallbackFN, RegionsListenerCallbackFN, RegionsValue, StationsListenerCallbackFN, StationsValue, ParentStationsListenerCallbackFN, ParentStationsValue } from "../types/autocomplete"
import {SEInputEventNameEnum} from "../enums/SEInputEventNameEnum"

export const emitAutocompleteValue = (value: AutocompleteValue | null) => {
    const event = new CustomEvent(
        SEInputEventNameEnum.AUTOCOMPLETE,
        { detail: value }
    )
    window.dispatchEvent(event)
}
export const emitParticipantsValue = (value: ParticipantsValue | null) => {
    const event = new CustomEvent(
        SEInputEventNameEnum.PARTICIPANTS,
        { detail: value }
    )
    window.dispatchEvent(event)
}
export const emitRegionsValue = (value: any) => {
    const event = new CustomEvent(
        SEInputEventNameEnum.REGIONS,
        { detail: value }
    )
    window.dispatchEvent(event)
}
export const emitStationsValue = (value: any) => {
    const event = new CustomEvent(
        SEInputEventNameEnum.STATIONS,
        { detail: value }
    )
    window.dispatchEvent(event)
}
export const emitParentStationsValue = (value: any) => {
    const event = new CustomEvent(
        SEInputEventNameEnum.PARENT_STATIONS,
        { detail: value }
    )
    window.dispatchEvent(event)
}

export const setAutocompleteValueListener = (callback: AutocompleteListenerCallbackFN) => {
    window.addEventListener(SEInputEventNameEnum.AUTOCOMPLETE, (e: any) => {
        const autocompleteValue: AutocompleteValue | null = e.detail || null
        callback(autocompleteValue)
    })
}
export const setParticipantsValueListener = (callback: ParticipantsListenerCallbackFN) => {
    window.addEventListener(SEInputEventNameEnum.PARTICIPANTS, (e: any) => {
        const participantsValue: ParticipantsValue | null = e.detail || null
        callback(participantsValue)
    })
}
export const setRegionsValueListener = (callback: RegionsListenerCallbackFN) => {
    window.addEventListener(SEInputEventNameEnum.REGIONS, (e: any) => {
        const regionsValue: RegionsValue | null = e.detail || null
        callback(regionsValue)
    })
}
export const setStationsValueListener = (callback: StationsListenerCallbackFN) => {
    window.addEventListener(SEInputEventNameEnum.STATIONS, (e: any) => {
        const stationsValue: StationsValue | null = e.detail || null
        callback(stationsValue)
    })
}
export const setParentStationsValueListener = (callback: ParentStationsListenerCallbackFN) => {
    window.addEventListener(SEInputEventNameEnum.PARENT_STATIONS, (e: any) => {
        const parentStationsValue: ParentStationsValue | null = e.detail || null
        callback(parentStationsValue)
    })
}